const getters = {
    token: (state: any) => state.user.token,
    language: (state: any) => state.lang.language,
    cachedViews: (state: any) => state.lang.cachedViews,
    goodInfo: (state: any) => state.good.goodInfo,
    is_fold: (state: any) => state.lang.is_fold,
    iframe_path: (state: any) => state.view.iframe_path,
    user_info: (state: any) => state.user.userInfo,
}
export default getters